import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { DocumentSegment, NGXLogger } from '@app/shared';

import { environment } from 'environments/environment';
import { RequestService } from './request.service';
import { URLSearchParams } from '@angular/http';


@Injectable()
export class DocumentSegmentService implements RequestService {

  redirectUrl: String = "";
  isBusy = false;
  private serviceUrl = 'documentSegment';  // URL to web api

  constructor(
    private http: HttpClient, private logger:NGXLogger
    ) { }


  /** GET product by id. Will 404 if id not found */
  /** GET product by id. Will 404 if id not found */
  getDocumentSegments(val:string): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    const url = `${environment.baseURL}${this.serviceUrl}/${val}`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    this.logger.debug(url)
    this.logger.debug(encodeURI(url))
    return this.http.get<DocumentSegment[]>(encodeURI(url),{
       //params : httpParams
       headers: headers
    })
  }


  getDocumentSegment(uuid:string): Observable<any> {
    const url = `${environment.baseURL}page/${uuid}?include=publicOffers&include=offerAllocation&include=publicOffers.offerViews&include=publicOffers.offerViews.viewTemplate&include=publicOffers.offerType&include=offerAllocation.publicOffers&include=offerAllocation.publicOffers.offerType&include=pageBackground&include=pageTemplate&include=offerAllocation.publicOffers.disclaimers&include=publicOffers.disclaimers&include=offerAllocation.viewTemplate`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<any>(url,{
       //params : httpParams
       headers: headers
    })
  }

  updateDocumentSegment(ds:DocumentSegment): Observable<any> {

    const url = `${environment.baseURL}page/save`;
    const ignoreKeys = ['publicOfferAssets','publicOffers'];
    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    let urlSearchParams = new URLSearchParams();


    //let data = JSON.stringify(ds);
    let data = new DocumentSegment();

    Object.keys(ds).forEach(function (key) {

      if(ignoreKeys.indexOf(key) === -1 && ds[key])
        data[key] = ds[key];
      else
        delete data[key];

    });
    urlSearchParams.append('data',JSON.stringify(data));
    let bodyParams = urlSearchParams.toString();

    return this.http.post<DocumentSegment>(url,bodyParams,{
      //params : httpParams
      headers: headers
    });

  }
  setDocumentSegmentLock(code:string,lockStatus:string): Observable<any> {

    const url = `${environment.baseURL}page/lock`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    let urlSearchParams = new URLSearchParams();
    urlSearchParams.append('pageUUID',code);
    urlSearchParams.append('lockStatus',lockStatus);
    let bodyParams = urlSearchParams.toString();

    return this.http.post<DocumentSegment>(url,bodyParams,{
       //params : httpParams
       headers: headers
    })
  }
  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T> (operation = 'operation', result?: T) {

    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better documentSegment of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.

      return of(result as T);
    };
  }
  /** Log a UserService message with the MessageService */
  private log(message: string) {
    //this.messageService.add('UserService: ' + message);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/core/services/documentSegment.service.ts